import { Injectable } from '@angular/core';
import { StorageService } from '../storage.service';
import { Router } from '@angular/router';

@Injectable()
export class AuthAssetsService {
  constructor(public storage: StorageService, public router: Router) {}

  public isAuthenticated(): boolean {
    const token = this.storage.get(StorageService.SESSION_COOKIE);
    return token !== null;
  }

  public isFirstVisit(): boolean {
    const wasVisited = this.storage.get(StorageService.WAS_VISITED);
    if (!wasVisited) {
      document.body.addEventListener('click', () => {
        this.storage.setVisit();
        document.body.removeEventListener('click', () => this.storage.setVisit());
      });
    }
    return wasVisited === null;
  }
}
